import { createSelector } from "@ngrx/store";
import { ReportsState, ReportDataState, linescoreLoaded, linescoreEntity, brandsLoaded, brandsEntity, verbatimsLoaded, verbatimsEntity, otherLoaded, otherEntity, driverLoaded, ratingsEntity, ratingsLoaded, linescoreLoading, brandsLoading, verbatimsLoading, driverLoading, ratingsLoading, otherLoading, loadedStatuses, loadingStatuses, driverItems, cellLoaded, cell, cellLoading } from "../reducers";

export const reportsState = (state: ReportsState) => state.data;

export const getLinescoreLoaded = createSelector(reportsState, linescoreLoaded);
export const getLinescoreEntity = createSelector(reportsState, linescoreEntity);
export const getLinescoreLoading = createSelector(reportsState, linescoreLoading);

export const getBrandsLoaded = createSelector(reportsState, brandsLoaded);
export const getBrandsLoading = createSelector(reportsState, brandsLoading);
export const getBrandsEntity = createSelector(reportsState, brandsEntity);

export const getVerbatimsLoaded = createSelector(reportsState, verbatimsLoaded);
export const getVerbatimsEntity = createSelector(reportsState, verbatimsEntity);
export const getVerbatimsLoading = createSelector(reportsState, verbatimsLoading);
export const getAcceptors = createSelector(getVerbatimsEntity, verbatims => verbatims.Acceptors);
export const getBorderline = createSelector(getVerbatimsEntity, verbatims => verbatims.Borderline);
export const getRejectors = createSelector(getVerbatimsEntity, verbatims => verbatims.Rejectors);
export const getIndiferrent = createSelector(getVerbatimsEntity, verbatims => verbatims.Indifferent);

export const getOtherLoaded = createSelector(reportsState, otherLoaded);
export const getOtherLoading = createSelector(reportsState, otherLoading);
export const getOtherEntity = createSelector(reportsState, otherEntity);

export const getDriverLoaded = createSelector(reportsState, driverLoaded);
export const getDriverLoading = createSelector(reportsState, driverLoading);
// export const getDriverEntity = createSelector(reportsState, driverEntity);
export const getDriverItems = createSelector(reportsState, driverItems);

export const getRatingsLoaded = createSelector(reportsState, ratingsLoaded);
export const getRatingsLoading = createSelector(reportsState, ratingsLoading);
export const getRatingsEntity = createSelector(reportsState, ratingsEntity);

export const getCellLoaded = createSelector(reportsState, cellLoaded);
export const getCellLoading = createSelector(reportsState, cellLoading);
export const getCell = createSelector(reportsState, cell);

export const getAllLoaded = createSelector(getLinescoreLoaded, getBrandsLoaded, getOtherLoaded, getDriverLoaded, getRatingsLoaded, (l1, l2, l3, l4, l5) => l1 && l2 && l3 && l4 && l5);

// export const getLinescores = createSelector(reportsState, linescores);

export const getIds = createSelector(reportsState, (state: ReportDataState, props: { tabName: string }) => state[props.tabName] ? state[props.tabName].ids : []);

export const getAllEntities = createSelector(reportsState, state => {
    return Object.keys(state)
        .filter(key => key !== 'verbatims')
        .map(key => state[key].entities)
        .reduce((entities, tabEnts) => [
            ...entities,
            ...Object.keys(tabEnts).reduce((items, key) => [
                ...items, tabEnts[key]
            ], [])
        ], []);
});

export const getLoadedStatuses = createSelector(reportsState, loadedStatuses);
export const getLoadingStatuses = createSelector(reportsState, loadingStatuses);